<template>
    <form-dialog
        :class="currentThemeClass"
        :title="title"
        :data="item"
        width="80%"
        :visible.sync="visibleSync"
        :columns="columnList"
        @confirm="confirmForm"
        :footerVisible="footerVisible"
        @extrabutton-click="ExtraButtonClick"
    ></form-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `EditApplySurgeryNew`,
    props: {
        visible: { type: Boolean },
        data: { type: Object },
        title: { type: String },
        footerVisible: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            surgeryId: undefined,
            item: {
                surgery_items: [{
                    is_empty: true
                }]
            },
            removeItems: [],
            isWorkerByDuty: this.$root.IsWorkerByDuty
        }
    },
    created() {
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.$store.dispatch(`surgery/ADD_ANAESTHESIA_METHOD`)
        this.$store.dispatch(`ADD_SECTION_AUTH`)
        this.$store.dispatch(`ADD_Inpatient_Section_AUTH`)
        this.$store.dispatch(`ADD_OPERATION_WARD_AUTH`)
    },
    computed: {
        currentThemeClass() {
            return localStorage.getItem(`app_theme`) || `theme-dark`
        },
        ...mapGetters([
            `surgery/visit_type`,
            `surgery/anaesthesia_method`,
            `operation_room_auth`,
            `section_auth`,
            `inpatient_section_auth`,
            `operation_ward_auth`,
            `sys_enums`,
            `sysuser/workers_by_duty`,
            `sysuser/workers_by_dutyNew`,
            `permissions`,
            `screenHeight`,
            `otherSettingColumn`,
            `extendColumnList`
        ]),
        worker() {
            if (this.isWorkerByDuty == `0`) {
                return this[`sysuser/workers_by_duty`]
            } else if (this.isWorkerByDuty == `1`) {
                return this[`sysuser/workers_by_dutyNew`]
            }
        },
        columnList() {
            let detaileditWorker = this.permissions && this.permissions.findIndex(item => item.permission === `scheduling:detail_editWorker`) === -1
            let editWorker = this.item.id !== undefined && detaileditWorker
            // 显示新增列
            let createC = [
                {
                    type: `p`,
                    prop: `title1`,
                    isCreatable: true,
                    isEditable: true,
                    placeholder: `　基本信息`,
                    colspan: 24,
                    label: { content: ` `, position: `top` }
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `姓名`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `enum_sex`,
                    label: `性别`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    options: this.sys_enums.Enum_Sex || []
                },
                {
                    type: `string`,
                    prop: `visit_no`,
                    label: this.T(`apply_surgery_new.visit_no`),
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `enum_visit_type`,
                    label: `就诊类型`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    default: 1,
                    options: this.sys_enums.VisitType || [],
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `outpatient_no`,
                    label: `门诊号`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `remoteselect`,
                    prop: `sectionobj`,
                    label: `科室`,
                    isCreatable: true,
                    isEditable: true,
                    options: (that, { row }) => {
                        return q => {
                            let sections = _.cloneDeep(this[`section_auth`])
                            console.log(`sections`, sections)
                            if (q && q.keyword) {
                                let f = sections.filter(d => {
                                    return d.code.indexOf(q.keyword) > -1 || d.label.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                                console.log(`f`, f)
                                return f
                            } else {
                                console.log(`search`, sections)
                                return sections
                            }
                        }
                    },
                    colspan: 6,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `remoteselect`,
                    prop: `inpatientobj`,
                    label: `病区`,
                    isCreatable: true,
                    isEditable: true,
                    options: (that, { row }) => {
                        return q => {
                            let sections = _.cloneDeep(this[`inpatient_section_auth`])
                            console.log(`sections`, sections)
                            if (q && q.keyword) {
                                let f = sections.filter(d => {
                                    return d.code.indexOf(q.keyword) > -1 || d.label.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                                console.log(`f`, f)
                                return f
                            } else {
                                console.log(`search`, sections)
                                return sections
                            }
                        }
                    },
                    colspan: 6,
                    default: this.dic_section_surgery
                },
                {
                    type: `string`,
                    prop: `bed_no`,
                    label: `床号`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `datetime`,
                    prop: `visit_time`,
                    label: `入院时间`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `date`,
                    prop: `birthday`,
                    label: `出生日期`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    change: (that, { row }) => {
                        let bir = row.birthday
                        let currentDate = this.$moment()
                        let birthDate = this.$moment(bir || ``)
                        let age = this.$moment.duration(currentDate.diff(birthDate))._data
                        row.age = age.years == 0 ? (age.months == 0 ? `${age.days}天` : `${age.months}月`) : `${age.years}岁`
                    }
                },
                {
                    type: `string`,
                    prop: `age`,
                    label: `年龄`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `card_type`,
                    label: `证件类型`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    options: this.sys_enums.Enum_CardType || []
                },
                {
                    type: `string`,
                    prop: `card_no`,
                    label: `证件号`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `enum_pay_type`,
                    label: `费用类别`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_PayType || [],
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `insurance_no`,
                    label: `社保卡号`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `enum_blood_type`,
                    label: `血型`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_BloodType || [],
                    colspan: 3
                },
                {
                    type: `select`,
                    prop: `enum_rh_blood_type`,
                    label: `RH`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_RhBloodType || [],
                    colspan: 3
                },

                {
                    type: `string`,
                    prop: `phone`,
                    label: `电话`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `height`,
                    label: `身高(cm)`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `weight`,
                    label: `体重(kg)`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `address`,
                    label: `地址`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12
                },
                {
                    type: `p`,
                    prop: `title2`,
                    isCreatable: true,
                    isEditable: true,
                    placeholder: `术前诊断`,
                    colspan: 24,
                    label: { content: ` `, position: `top` }
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_diseases`,
                    label: `术前诊断`,
                    showCount: 9,
                    collapseTags: false,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 24,
                    options: `/api/AcisSystem/Disease/Search`,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `p`,
                    prop: `title2`,
                    isCreatable: true,
                    isEditable: true,
                    placeholder: `手术项`,
                    colspan: 24,
                    label: { content: ` `, position: `top` }
                },
                {
                    type: `table2`,
                    prop: `surgery_items`,
                    label: ``,
                    isEditable: true,
                    isCreatable: true,
                    options: [{
                        type: `string`,
                        prop: `id`,
                        label: `id`,
                        isKey: true
                    },
                    {
                        type: `remoteselect`,
                        prop: `plan_surgeries`,
                        label: `拟施手术`,
                        showCount: 1,
                        isListable: true,
                        readonly: false,
                        colspan: 4,
                        options: `/api/AcisSystem/Surgery/SearchIncludOpeLevel`,
                        change: (that, { row, area }) => {
                            if (row.is_empty) {
                                this.$set(row, `is_empty`, false)
                                this.item.surgery_items.push({ is_empty: true })
                            }
                            if (_.isEmpty(row.plan_surgeries)) {
                                row.plan_surgery_scale = undefined
                            } else {
                                var max = -1
                                try {
                                    if (row.plan_surgeries.description) {
                                        let level = parseInt(row.plan_surgeries.description)
                                        if (level > max) { max = level }
                                    }
                                } catch (err) {
                                    console.log(err)
                                }
                                if (max > 0) {
                                    row.plan_surgery_scale = max
                                } else {
                                    row.plan_surgery_scale = undefined
                                }
                            }
                        },
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }]

                    },
                    {
                        type: `select`,
                        prop: `plan_surgery_scale`,
                        label: `手术等级`,
                        isListable: true,
                        readonly: false,
                        options: this.sys_enums.Enum_SurgeryScale || [],
                        colspan: 4,
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                    },
                    {
                        type: `select`,
                        prop: `plan_enum_cut_level`,
                        label: `切口等级`,
                        isListable: true,
                        readonly: false,
                        options: this.sys_enums.Enum_CutLevel || [],
                        colspan: 4,
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                    },
                    {
                        type: `select`,
                        prop: `plan_surgery_region`,
                        label: `部位`,
                        isCreatable: true,
                        isListable: true,
                        readonly: false,
                        options: this.sys_enums.Enum_Region || [],
                        colspan: 4,
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                    },
                    {
                        type: `select`,
                        prop: `plan_surgery_position`,
                        label: `体位`,
                        isCreatable: true,
                        isListable: true,
                        readonly: false,
                        options: this.sys_enums.Enum_Position || [],
                        colspan: 4,
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                    },
                    {
                        type: `select`,
                        prop: `plan_anaes_method`,
                        label: `麻醉方式`,
                        isListable: true,
                        readonly: false,
                        options: (that, { row }) => {
                            return _.filter(this[`surgery/anaesthesia_method`], function(i) { return (i.enum_dic_type === 1 || i.enum_dic_type === 2) })
                        },
                        colspan: 4,
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                    },
                    {
                        type: `buttongroup`,
                        prop: `oper`,
                        label: `操作`,
                        width: `60`,
                        isListable: true,
                        fixed: `right`,
                        readonly: false,
                        options: (that, { row }) => {
                            return row.is_empty || !row.plan_surgeries
                                ? []
                                : [
                                    {
                                        class: `is-plain is-circle`,
                                        label: ``,
                                        icon: `el-icon-close`,
                                        type: `danger`,
                                        emit: `removeItem`,
                                        permission: `default`
                                    }
                                ]
                        }
                    }
                    ],
                    colspan: 24,
                    default: [{
                        is_empty: true
                    }]
                },
                {
                    type: `p`,
                    prop: `title2`,
                    isCreatable: true,
                    isEditable: true,
                    placeholder: `手术信息项`,
                    colspan: 24,
                    label: { content: ` `, position: `top` }
                },
                {
                    type: `datetime`,
                    prop: `plan_time`,
                    label: `手术时间`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    default: this.$moment().format(`YYYY/MM/DD 09:00:00`),
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `float`,
                    prop: `cost_time`,
                    label: `预计时长`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `enum_surgery_type`,
                    label: `手术类型`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_SurgeryType || [],
                    colspan: 6,
                    default: 1
                },
                {
                    type: `select`,
                    prop: `enum_isolation_status`,
                    label: `隔离状态`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.IsolationStatus || [],
                    colspan: 6
                },
                {

                    type: `remoteselect`,
                    prop: `plan_surgeon`,
                    label: `主刀医生`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    options: (that, { row }) => {
                        return q => {
                            let deepworkers = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`手术医生`] || []
                            let works = _.cloneDeep(deepworkers)
                            if (this.$root.UseSurgeryScaleCheck == `1`) {
                                works = works.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        code: d.surgery_scale == null ? `--/${d.code}` : d.surgery_scale + `/` + d.code
                                    }
                                })
                            }
                            if (q && q.keyword) {
                                let f = works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                                return f
                            } else {
                                return works
                            }
                        }
                    },
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_surgeon_assistants`,
                    label: `手术助手`,
                    isCreatable: true,
                    isEditable: true,
                    showCount: 3,
                    collapseTags: false,
                    colspan: 6,
                    options: (that, { row }) => {
                        return q => {
                            let r = {
                                workerRole: 1,
                                keyword: q && q.keyword
                            }
                            return this.myaxios.get(`/api/AcisSystem/Worker/RemoteSearch`, r).then(
                                res => {
                                    if (this.$root.UseSurgeryScaleCheck == `1`) {
                                        return res.map(d => {
                                            return {
                                                label: d.label,
                                                value: d.value,
                                                jianpin: d.jianpin,
                                                card_no: d.card_no,
                                                worker_duty: d.worker_duty,
                                                code: d.surgery_scale == null ? `--/${d.code}` : d.surgery_scale + `/` + d.code
                                            }
                                        })
                                    } else {
                                        return res.map(d => {
                                            return {
                                                label: d.label,
                                                value: d.value,
                                                jianpin: d.jianpin,
                                                card_no: d.card_no,
                                                worker_duty: d.worker_duty,
                                                code: d.code
                                            }
                                        })
                                    }
                                },
                                res => {
                                    console.log(`error`) // 调用失败
                                }
                            )
                        }
                    }
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_surgery_guidance`,
                    label: `手术指导`,
                    isCreatable: true,
                    isEditable: true,
                    showCount: 3,
                    collapseTags: false,
                    colspan: 6,
                    options: (that, { row }) => {
                        return q => {
                            let r = {
                                workerRole: 1,
                                keyword: q && q.keyword
                            }
                            return this.myaxios.get(`/api/AcisSystem/Worker/RemoteSearch`, r).then(
                                res => {
                                    if (this.$root.UseSurgeryScaleCheck == `1`) {
                                        return res.map(d => {
                                            return {
                                                label: d.label,
                                                value: d.value,
                                                jianpin: d.jianpin,
                                                card_no: d.card_no,
                                                worker_duty: d.worker_duty,
                                                code: d.surgery_scale == null ? `--/${d.code}` : d.surgery_scale + `/` + d.code
                                            }
                                        })
                                    } else {
                                        return res.map(d => {
                                            return {
                                                label: d.label,
                                                value: d.value,
                                                jianpin: d.jianpin,
                                                card_no: d.card_no,
                                                worker_duty: d.worker_duty,
                                                code: d.code
                                            }
                                        })
                                    }
                                },
                                res => {
                                    console.log(`error`) // 调用失败
                                }
                            )
                        }
                    }
                },

                {
                    type: `select`,
                    prop: `is_day_surgery`,
                    label: `日间手术`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    options: `enum_bool`
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_anes_doctor`,
                    label: `麻醉医生`,
                    showCount: 3,
                    collapseTags: false,
                    isCreatable: true,
                    isEditable: true,
                    readonly: editWorker,
                    options: (that, { row }) => {
                        return q => {
                            let deepworkers = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                            let works = _.cloneDeep(deepworkers)
                            if (this.$root.UseASACheck == `1`) {
                                works = works.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code
                                    }
                                })
                            }
                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    },
                    colspan: 6
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_anes_assistants`,
                    label: `麻醉助手`,
                    isCreatable: true,
                    showCount: 3,
                    collapseTags: false,
                    isEditable: true,
                    readonly: editWorker,
                    options: (that, { row }) => { // added by xiaorui,ACIS-23399  排程界面的麻醉助手权限改动：既可以选择医生，又可选择护士
                        return q => {
                            let deepworkers = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                            let works = _.cloneDeep(deepworkers)
                            if (this.$root.UseASACheck == `1`) {
                                works = works.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code
                                    }
                                })
                            }
                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    },
                    colspan: 6
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_anes_guidance`,
                    label: `麻醉指导`,
                    isCreatable: true,
                    isEditable: true,
                    showCount: 3,
                    collapseTags: false,
                    options: (that, { row }) => { // added by xiaorui,ACIS-23399  排程界面的麻醉助手权限改动：既可以选择医生，又可选择护士
                        return q => {
                            // added by xiaorui,ACIS-23399  排程界面的麻醉助手权限改动：既可以选择医生，又可选择护士
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                            let deepworkers = _.cloneDeep(works)
                            let hsworkers = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            hsworkers.forEach((item, index) => {
                                let mc = _.find(deepworkers, x => x.value == item.value)
                                if (mc) {
                                } else {
                                    deepworkers.push(item)
                                }
                            })
                            if (this.$root.UseASACheck == `1`) {
                                deepworkers = deepworkers.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        //  code: d.code,
                                        // worker_duty:d.worker_duty=="麻醉助手"?"麻醉医生":(d.worker_duty=="手术助手"?"手术医生":(d.worker_duty=="器械护士"?"巡回护士":d.worker_duty)),
                                        code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code
                                        // code: d.surgery_scale == null ? `--/${d.code}` : d.surgery_scale + `/` + d.code
                                    }
                                })
                            }
                            if (q && q.keyword) {
                                return deepworkers.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return deepworkers
                            }
                        }
                    },
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `is_endoscopy`,
                    label: `内镜检查`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    options: `enum_bool`
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_circuit_nurse`,
                    label: `巡回护士`,
                    showCount: 3,
                    collapseTags: false,
                    isCreatable: true,
                    isEditable: true,
                    readonly: editWorker,
                    options: (that, { row }) => {
                        return q => {
                            let deepworkers = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            let works = _.cloneDeep(deepworkers)
                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    },
                    colspan: 6
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_equipment_nurse`,
                    label: this.T(`apply_surgery.plan_equipment_nurse`),
                    isCreatable: true,
                    isEditable: true,
                    showCount: 3,
                    collapseTags: false,
                    readonly: editWorker,
                    options: (that, { row }) => {
                        return q => {
                            let deepworkers = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            let works = _.cloneDeep(deepworkers)
                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    },
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `dic_operating_ward_id`,
                    label: `手术区`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.operation_ward_auth || [],
                    colspan: 6,
                    default: this.dic_operating_ward_id,
                    validate: [{ required: true, message: `必填项目`, trigger: `change` }],
                    change: (that, { row }) => {
                        row.dic_operating_room_id = undefined
                    }
                },
                {
                    type: `select`,
                    prop: `dic_operating_room_id`,
                    label: `手术间`,
                    isCreatable: true,
                    isEditable: true,
                    options: (that, { row }) => {
                        let r = _.filter(this[`operation_ward_auth`], { value: row.dic_operating_ward_id })
                        return (r && r[0] && r[0].operation_room) || []
                    },
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `enum_asa`,
                    label: `ASA`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_ASA || [],
                    colspan: 6
                },
                {
                    type: `multiselect`,
                    prop: `infectious`,
                    label: `传染病`,
                    isCreatable: true,
                    isEditable: true,
                    // options: `enum_infectious`,
                    options: (that, { row }) => {
                        let data = this.sys_enums.Enum_Infectious || []
                        var ret = data.map(d => {
                            d.value = d.label
                            return d
                        })
                        return ret
                    },
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `is_fasting`,
                    label: `术前禁食`,
                    isCreatable: true,
                    isEditable: true,
                    options: `enum_bool`,
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `his_remark`,
                    label: `申请备注`,
                    isCreatable: false,
                    isEditable: true,
                    readonly: true,
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `remark`,
                    label: `备注`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 24
                }

            ]

            // 批处理是否可编辑那些属性
            createC = this.$surgeryInfoExtraParamUtil.SetOtherSettingColumn(createC, this.otherSettingColumn)
            // 显示动态扩展列
            createC = this.$surgeryInfoExtraParamUtil.SetExtraColumnList(this.extendColumnList, createC)
            createC = _.filter(createC, function(d) {
                return d.isCreatable === true || d.isEditable === true
            })
            return createC
        },
        visibleSync: {
            get: function() {
                if (this.visible) {
                    this.loadOne()
                }
                return this.visible
            },
            set: function(newval) {
                this.$emit(`update:visible`, newval)
            }
        }
    },
    methods: {
        loadOne() {
            this.item = this.data
            this.removeItems = []
            if (_.findIndex(this.item.surgery_items, { is_empty: true }) == -1) {
                this.item.surgery_items.push({ is_empty: true })
            }
        },
        saveOne(row) {
            let data = row
            try {
                var pddata = _.filter(data.surgery_items, function(u) {
                    return u.is_empty == undefined || u.is_empty == false
                })
                pddata.forEach(d => {
                    if (d.plan_surgeries == null) {
                        this.$message.error(`请选择拟施手术！`)
                        throw new Error(`EndIterative`)
                    }
                    if (d.plan_surgery_scale == null) {
                        this.$message.error(`请选择手术等级！`)
                        throw new Error(`EndIterative`)
                    }
                    if (d.plan_enum_cut_level == null) {
                        this.$message.error(`请选择切口等级！`)
                        throw new Error(`EndIterative`)
                    }
                    if (d.plan_surgery_region == null) {
                        this.$message.error(`请选择部位！`)
                        throw new Error(`EndIterative`)
                    }
                    if (d.plan_surgery_position == null) {
                        this.$message.error(`请选择体位！`)
                        throw new Error(`EndIterative`)
                    }
                    if (d.plan_anaes_method == null) {
                        this.$message.error(`请选择麻醉方式！`)
                        throw new Error(`EndIterative`)
                    }
                })

                let r = _.groupBy(pddata, d => d.plan_surgeries.value)
                _.forEach(r, (g) => {
                    if (g.length > 1) {
                        this.$message.error(`拟施手术重复`)
                        throw new Error(`EndIterative`)
                    }
                })
            } catch (e) {
                if (e.message != `EndIterative`) throw e
                return
            }
            if (row.id > 0) {
                let sItems = _.filter(data.surgery_items, function(u) {
                    return u.is_empty == undefined || u.is_empty == false
                }).map(d => {
                    d.plan_surgeries = d.plan_surgeries.value
                    return d
                })
                let obj = {
                    id: data.id,
                    sequence: data.sequence,
                    plan_time: data.plan_time,
                    cost_time: data.cost_time,
                    infectious: data.infectious && data.infectious.join(`,`),
                    is_fasting: data.is_fasting,
                    is_day_surgery: data.is_day_surgery,
                    is_endoscopy: data.is_endoscopy,
                    remark: data.remark,
                    enum_asa: data.enum_asa || `-1`,
                    enum_surgery_scale: data.enum_surgery_scale || `-1`,
                    enum_surgery_type: data.enum_surgery_type || `-1`,
                    dic_section_id: data.sectionobj && data.sectionobj.value || `-1`,
                    dic_inpatient_section_id: data.inpatientobj && data.inpatientobj.value || `-1`,
                    dic_operating_room_id: data.dic_operating_room_id || `-1`,
                    dic_operating_ward_id: data.dic_operating_ward_id || `-1`,
                    enum_isolation_status: data.enum_isolation_status || `-1`,
                    enum_cut_level: data.enum_cut_level || `-1`,
                    visit_info: {
                        age: data.age,
                        height: data.height,
                        weight: data.weight,
                        bed_no: data.bed_no,
                        visit_no: data.visit_no,
                        outpatient_no: data.outpatient_no,
                        visit_time: data.visit_time,
                        phone: data.phone,
                        address: data.address,
                        enum_visit_type: data.enum_visit_type || `-1`,
                        enum_pay_type: data.enum_pay_type || `-1`,
                        name: data.name,
                        birthday: data.birthday,
                        card_type: data.card_type,
                        card_no: data.card_no,
                        insurance_no: data.insurance_no,
                        enum_blood_type: data.enum_blood_type || `-1`,
                        enum_rh_blood_type: data.enum_rh_blood_type || `-1`,
                        enum_sex: data.enum_sex === `` ? `-1` : data.enum_sex
                    },
                    // plan_anaes_methods: data.plan_anaes_methods,
                    plan_diseases: data.plan_diseases && data.plan_diseases.map(d => d.value),
                    plan_surgeon: data.plan_surgeon && data.plan_surgeon.value || `-1`,
                    plan_surgeon_assistants: data.plan_surgeon_assistants && data.plan_surgeon_assistants.map(d => d.value),
                    plan_anes_doctor: data.plan_anes_doctor && data.plan_anes_doctor.map(d => d.value),
                    plan_anes_assistants: data.plan_anes_assistants && data.plan_anes_assistants.map(d => d.value),
                    plan_circuit_nurse: data.plan_circuit_nurse && data.plan_circuit_nurse.map(d => d.value),
                    plan_equipment_nurse: data.plan_equipment_nurse && data.plan_equipment_nurse.map(d => d.value),
                    plan_surgery_guidance: data.plan_surgery_guidance && data.plan_surgery_guidance.map(d => d.value),
                    plan_anes_guidance: data.plan_anes_guidance && data.plan_anes_guidance.map(d => d.value),
                    surgery_items: sItems
                }
                console.log(`plan_surgeon_assistants`, data.plan_surgeon_assistants)
                this.$surgeryInfoExtraParamUtil.SetSurgeryInfoExtraDatas(this.extendColumnList, obj, data)
                let req = this.myaxios.put(`/api/Preoperative/Apply/NewPut`, obj)

                let reqs2 = _.map(this.removeItems, d => {
                    return this.myaxios.delete(`/api/Preoperative/Apply/DeleteArrangeSurgery?arrangeSurgeryId=${d.id}`)
                })
                req = reqs2.concat(req)
                return new Promise((resolve, reject) => {
                    this.myaxios
                        .all(...req).then(res => {
                            resolve(res)
                        }).catch((e) => reject(e))
                })
            } else {
                let sItems = _.filter(data.surgery_items, { is_empty: false }).map(d => {
                    d.plan_surgeries = d.plan_surgeries.value
                    d.plan_surgery_region = d.plan_surgery_region
                    d.plan_surgery_position = d.plan_surgery_position
                    return d
                })
                let obj = {
                    sequence: data.sequence,
                    apply_time: data.apply_time,
                    plan_time: data.plan_time,
                    cost_time: data.cost_time,
                    infectious: data.infectious && data.infectious.join(`,`),
                    is_fasting: data.is_fasting,
                    is_day_surgery: data.is_day_surgery,
                    is_endoscopy: data.is_endoscopy,
                    remark: data.remark,
                    enum_asa: data.enum_asa,
                    enum_surgery_scale: data.enum_surgery_scale,
                    enum_surgery_type: data.enum_surgery_type,
                    dic_section_id: data.sectionobj && data.sectionobj.value || `-1`,
                    dic_inpatient_section_id: data.inpatientobj && data.inpatientobj.value || `-1`,
                    dic_operating_room_id: data.dic_operating_room_id,
                    dic_operating_room: data.dic_operating_room,
                    dic_operating_ward_id: data.dic_operating_ward_id,
                    enum_isolation_status: data.enum_isolation_status,
                    enum_cut_level: data.enum_cut_level,
                    iconValue: `el-icon-star-on`,
                    visit_info: {
                        age: data.age,
                        height: data.height,
                        weight: data.weight,
                        bed_no: data.bed_no,
                        visit_no: data.visit_no,
                        outpatient_no: data.outpatient_no,
                        visit_time: data.visit_time,
                        phone: data.phone,
                        address: data.address,
                        enum_visit_type: data.enum_visit_type,
                        enum_pay_type: data.enum_pay_type,
                        name: data.name,
                        birthday: data.birthday,
                        card_type: data.card_type,
                        card_no: data.card_no,
                        insurance_no: data.insurance_no,
                        enum_blood_type: data.enum_blood_type,
                        enum_rh_blood_type: data.enum_rh_blood_type,
                        enum_sex: data.enum_sex
                    },
                    // plan_anaes_methods: data.plan_anaes_methods,
                    plan_diseases: data.plan_diseases && data.plan_diseases.map(d => d.value),
                    plan_surgeon: data.plan_surgeon,
                    plan_surgeon_assistants: data.plan_surgeon_assistants,
                    plan_anes_doctor: data.plan_anes_doctor,
                    plan_anes_assistants: data.plan_anes_assistants,
                    plan_circuit_nurse: data.plan_circuit_nurse,
                    plan_equipment_nurse: data.plan_equipment_nurse,
                    plan_surgery_guidance: data.plan_surgery_guidance,
                    plan_anes_guidance: data.plan_anes_guidance,
                    surgery_items: sItems
                }
                this.$surgeryInfoExtraParamUtil.SetSurgeryInfoExtraDatas(this.extendColumnList, obj, data)
                let req = this.myaxios.post(`/api/Preoperative/Apply/NewPost`, obj)

                return new Promise((resolve, reject) => {
                    req.then(req => {
                        resolve(req)
                    }).catch(e => reject(e))
                })
            }
        },
        removeItem({ index }) {
            let row = this.item.surgery_items.splice(index, 1)[0]
            if (row.id) {
                this.removeItems.push(row)
            }
        },
        ExtraButtonClick({ emit, row, index }) {
            if (emit == `removeItem`) {
                this.removeItem(row)
            }
        },
        confirmForm(row) {
            try {
                this.saveOne(row).then(data => {
                    this.$emit(`save-success`)
                    this.visibleSync = false
                })
            } catch (e) {
                console.log(e)
            }
        },
        createOne(data, currentItem) {
            let sItems = _.filter(data.surgery_items, { is_empty: false })
            return new Promise((resolve, reject) => {
                let obj = {
                    sequence: data.sequence,
                    apply_time: data.apply_time,
                    plan_time: data.plan_time,
                    cost_time: data.cost_time,
                    infectious: data.infectious && data.infectious.join(`,`),
                    is_fasting: data.is_fasting,
                    is_day_surgery: data.is_day_surgery,
                    is_endoscopy: data.is_endoscopy,
                    remark: data.remark,
                    enum_asa: data.enum_asa,
                    enum_surgery_scale: data.enum_surgery_scale,
                    enum_surgery_type: data.enum_surgery_type,
                    dic_section_id: data.sectionobj && data.sectionobj.value || `-1`,
                    dic_inpatient_section_id: data.inpatientobj && data.inpatientobj.value || `-1`,
                    dic_operating_room_id: data.dic_operating_room_id,
                    dic_operating_room: data.dic_operating_room,
                    dic_operating_ward_id: data.dic_operating_ward_id,
                    enum_isolation_status: data.enum_isolation_status,
                    enum_cut_level: data.enum_cut_level,
                    iconValue: `el-icon-star-on`,
                    visit_info: {
                        age: data.age,
                        height: data.height,
                        weight: data.weight,
                        bed_no: data.bed_no,
                        visit_no: data.visit_no,
                        outpatient_no: data.outpatient_no,
                        visit_time: data.visit_time,
                        phone: data.phone,
                        address: data.address,
                        enum_visit_type: data.enum_visit_type,
                        enum_pay_type: data.enum_pay_type,
                        name: data.name,
                        birthday: data.birthday,
                        card_type: data.card_type,
                        card_no: data.card_no,
                        insurance_no: data.insurance_no,
                        enum_blood_type: data.enum_blood_type,
                        enum_rh_blood_type: data.enum_rh_blood_type,
                        enum_sex: data.enum_sex
                    },
                    // plan_anaes_methods: data.plan_anaes_methods,
                    plan_diseases: data.plan_diseases.map(d => d.value),
                    plan_surgeon: data.plan_surgeon,
                    plan_surgeon_assistants: data.plan_surgeon_assistants,
                    plan_anes_doctor: data.plan_anes_doctor,
                    plan_anes_assistants: data.plan_anes_assistants,
                    plan_circuit_nurse: data.plan_circuit_nurse,
                    plan_equipment_nurse: data.plan_equipment_nurse,
                    surgery_items: sItems
                }
                let req = this.myaxios.post(`/api/Preoperative/Apply/NewPost`, obj)
                this.$surgeryInfoExtraParamUtil.SetSurgeryInfoExtraDatas(this.extendColumnList, obj, data)

                req.then(res => {
                    resolve(res)
                }).catch((e) => reject(e))
            })
        }
    }
}
</script>
<style lang="less" scoped>
// /deep/.el-dialog {
//     margin-top: 42vh !important;
// }
</style>



// WEBPACK FOOTER //
// src/components/Scheduling/EditSurgeryNew.vue